import { render, staticRenderFns } from "./YingxunList.vue?vue&type=template&id=f5c69d78&scoped=true"
import script from "./YingxunList.vue?vue&type=script&lang=js"
export * from "./YingxunList.vue?vue&type=script&lang=js"
import style0 from "./YingxunList.vue?vue&type=style&index=0&id=f5c69d78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c69d78",
  null
  
)

export default component.exports